function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import { formatMoney } from '@shopify/theme-currency';

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';

// Styles
import './_card.scss';
var CARD_PRODUCT = '.card--product';
var CARD_COLOR_OPTION = '.card__swatch--color-option';
var CARD_COLOR_SWATCHES = '.card__color-swatches';
var CARD_LINK = '[data-product-card-link]';
var SELECTED_CLASS_NAME = 'selected';
function getCurrencyFormat() {
  return window.theme && window.theme.settingCurrencyFormat;
}
function formatCents(cents) {
  var n = Number(cents);
  if (Number.isNaN(n)) return '';
  return formatMoney(n, getCurrencyFormat());
}
function formatProductCardPercentOff(percent) {
  var tpl = window.theme && window.theme.strings && window.theme.strings.productCardPercentOff || '__PCT__% Off';
  return String(tpl).replace(/__PCT__/g, String(percent));
}
function parseCardVariants(card) {
  var script = card.querySelector('[data-product-card-variants]');
  if (!script) return null;
  try {
    return JSON.parse(script.textContent);
  } catch (_unused) {
    return null;
  }
}

/**
 * Applies variant image JSON (`primary` / `hover`) to the card DOM after swatch change.
 *
 * @param {HTMLElement | null} pictureWrap — `.card__picture` (may contain `<picture>` or a bare `<img>`)
 * @param {Record<string, unknown> | null} spec
 */
function applyPictureFromSpec(pictureWrap, spec) {
  var _spec$src;
  if (!pictureWrap || !spec || typeof spec !== 'object') return;
  var picture = pictureWrap.querySelector('picture');
  var img = pictureWrap.querySelector('img');
  if (!img) return;
  var src = String((_spec$src = spec.src) !== null && _spec$src !== void 0 ? _spec$src : '');
  img.src = src;
  var srcset = spec.srcset ? String(spec.srcset).trim() : '';
  if (srcset) {
    img.srcset = srcset;
  } else {
    img.removeAttribute('srcset');
  }
  if (spec.w != null) img.width = Number(spec.w);
  if (spec.h != null) img.height = Number(spec.h);
  img.alt = spec.alt != null ? String(spec.alt) : '';
  var zoomRaw = spec.zoomSrc != null ? String(spec.zoomSrc).trim() : '';
  img.dataset.zoom = zoomRaw || src;
  if (picture) {
    picture.querySelectorAll('source').forEach(el => el.remove());
    var dSrcset = spec.dSrcset ? String(spec.dSrcset).trim() : '';
    var mSrcset = spec.mSrcset ? String(spec.mSrcset).trim() : '';
    var media = spec.media ? String(spec.media) : '(min-width: 681px)';
    if (dSrcset) {
      var desktopSource = document.createElement('source');
      desktopSource.media = media;
      desktopSource.srcset = dSrcset;
      picture.insertBefore(desktopSource, img);
    }
    if (mSrcset) {
      var mobileSource = document.createElement('source');
      mobileSource.srcset = mSrcset;
      picture.insertBefore(mobileSource, img);
    }
  }
}
function syncProductCardTitleSuffix(card) {
  var suffixWrap = card.querySelector('[data-product-card-title-suffix]');
  var suffixText = card.querySelector('[data-product-card-title-suffix-text]');
  var linkLabel = card.querySelector('[data-product-card-link-label]');
  var nameEl = card.querySelector('.card__title-name');
  var baseTitle = nameEl != null ? nameEl.textContent : '';
  if (suffixWrap && suffixText) {
    suffixWrap.hidden = true;
    suffixText.textContent = '';
  }
  if (linkLabel) {
    linkLabel.textContent = baseTitle;
  }
}

/**
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardMedia(card, v) {
  var primaryWrap = card.querySelector('[data-card-primary-picture]');
  var hoverWrap = card.querySelector('[data-card-hover-picture]');
  if (v.primary) {
    applyPictureFromSpec(primaryWrap, /** @type {Record<string, unknown>} */v.primary);
  }
  if (v.hover) {
    if (hoverWrap) {
      hoverWrap.hidden = false;
      if (!hoverWrap.querySelector('img')) {
        var img = document.createElement('img');
        img.className = 'responsive-image__image card__product-image card__product-image--hover background-image';
        img.width = 1;
        img.height = 1;
        img.loading = 'lazy';
        img.decoding = 'async';
        hoverWrap.appendChild(img);
      }
    }
    applyPictureFromSpec(hoverWrap, /** @type {Record<string, unknown>} */v.hover);
  } else if (hoverWrap) {
    hoverWrap.hidden = true;
  }
}

/**
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardPriceRow(card, v) {
  var compareEl = card.querySelector('[data-product-card-compare]');
  var currentEl = card.querySelector('[data-product-card-current]');
  var compareText = card.querySelector('[data-compare-text]');
  var discountEl = card.querySelector('[data-product-card-discount]');
  var price = Number(v.price);
  var compareRaw = v.compareAtPrice;
  var compareAt = compareRaw != null && compareRaw !== '' ? Number(compareRaw) : 0;
  var isSale = !Number.isNaN(compareAt) && compareAt > price;
  if (currentEl) {
    currentEl.textContent = formatCents(price);
  }
  if (compareEl) {
    if (isSale) {
      compareEl.hidden = false;
      compareEl.textContent = formatCents(compareAt);
      if (compareText) compareText.hidden = false;
    } else {
      compareEl.hidden = true;
      compareEl.textContent = '';
      if (compareText) compareText.hidden = true;
    }
  }
  if (discountEl) {
    if (isSale && compareAt > 0) {
      var pct = Math.round((1 - price / compareAt) * 100);
      if (pct > 0) {
        discountEl.hidden = false;
        discountEl.textContent = formatProductCardPercentOff(pct);
      } else {
        discountEl.hidden = true;
        discountEl.textContent = '';
      }
    } else {
      discountEl.hidden = true;
      discountEl.textContent = '';
    }
  }
}

/**
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardPromo(card, v) {
  var promoEl = card.querySelector('[data-product-card-promo]');
  if (!promoEl) return;
  var promo = v.promo != null ? String(v.promo).trim() : '';
  if (promo) {
    promoEl.hidden = false;
    promoEl.textContent = promo;
  } else {
    promoEl.hidden = true;
    promoEl.textContent = '';
  }
}

/**
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardBadge(card, v) {
  var badge = card.querySelector('[data-product-card-badge]');
  if (!badge) return;
  var badgeTextEl = card.querySelector('[data-product-card-badge-text]');
  var badgeSr = card.querySelector('[data-product-card-badge-sr]');
  var kind = v.badgeKind != null ? String(v.badgeKind) : 'none';
  badge.dataset.badgeKind = kind;
  var mod = v.badgeModifier != null ? String(v.badgeModifier) : '';
  badge.className = 'card__product-badge' + (mod && kind !== 'none' ? " card__product-badge--".concat(mod) : '');
  if (kind === 'none') {
    badge.hidden = true;
    if (badgeTextEl) badgeTextEl.textContent = '';
    if (badgeSr) badgeSr.textContent = '';
  } else {
    badge.hidden = false;
    if (badgeTextEl) {
      badgeTextEl.textContent = v.badgeText != null ? String(v.badgeText) : '';
    }
    if (badgeSr) {
      badgeSr.textContent = v.badgeSr != null ? String(v.badgeSr) : '';
    }
  }
}

/**
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardIcon(card, v) {
  var iconWrap = card.querySelector('[data-product-card-icon-wrap]');
  var iconImg = card.querySelector('[data-product-card-icon]');
  if (!iconWrap || !iconImg) return;
  var url = v.iconUrl != null ? String(v.iconUrl).trim() : '';
  if (url) {
    iconWrap.hidden = false;
    iconImg.src = url;
    iconImg.alt = v.iconAlt != null ? String(v.iconAlt) : '';
  } else {
    iconWrap.hidden = true;
    iconImg.removeAttribute('src');
    iconImg.alt = '';
  }
}

/**
 * Re-points the card's cover link to the selected variant so clicking the card
 * lands on the colour the shopper picked (e.g. /products/foo?variant=123).
 *
 * @param {HTMLElement} card
 * @param {Record<string, unknown>} v
 */
function syncProductCardLink(card, v) {
  var url = v.url != null ? String(v.url).trim() : '';
  if (!url) return;
  card.querySelectorAll(CARD_LINK).forEach(link => link.setAttribute('href', url));
}

/**
 * @param {HTMLElement} card
 * @param {string | number} variantId
 */
function updateProductCardFromVariant(card, variantId) {
  var data = parseCardVariants(card);
  if (!data || !data.variants) return;
  var key = String(variantId);
  var v = data.variants[key];
  if (!v) return;
  syncProductCardLink(card, /** @type {Record<string, unknown>} */v);
  syncProductCardMedia(card, /** @type {Record<string, unknown>} */v);
  syncProductCardTitleSuffix(card, /** @type {Record<string, unknown>} */v);
  syncProductCardPriceRow(card, /** @type {Record<string, unknown>} */v);
  syncProductCardPromo(card, /** @type {Record<string, unknown>} */v);
  syncProductCardBadge(card, /** @type {Record<string, unknown>} */v);
  syncProductCardIcon(card, /** @type {Record<string, unknown>} */v);
}
function changeSwatch(swatchOption) {
  var row = swatchOption.closest(CARD_COLOR_SWATCHES);
  if (row) {
    row.querySelectorAll(".".concat(SELECTED_CLASS_NAME)).forEach(el => {
      el.classList.remove(SELECTED_CLASS_NAME);
    });
  }
  swatchOption.classList.add(SELECTED_CLASS_NAME);
  var productCard = swatchOption.closest(CARD_PRODUCT);
  var variantId = swatchOption.dataset.variantId;
  if (!productCard || !variantId) return;
  updateProductCardFromVariant(productCard, variantId);
}

/**
 * True on hover-capable (desktop) pointers. Touch devices with no hover match
 * `false`, which is what drives the mobile "tap previews, doesn't navigate" path.
 */
function isHoverDevice() {
  return typeof window.matchMedia === 'function' && window.matchMedia('(hover: hover)').matches;
}

/**
 * Resolves the PDP URL for a swatch from the card's variant JSON, falling back
 * to the card's cover link (which hover/tap has already re-pointed to the
 * selected variant via `syncProductCardLink`).
 *
 * @param {HTMLElement} swatchOption
 * @param {HTMLElement} productCard
 * @returns {string}
 */
function swatchVariantUrl(swatchOption, productCard) {
  var variantId = swatchOption.dataset.variantId;
  if (variantId) {
    var data = parseCardVariants(productCard);
    var v = data && data.variants ? data.variants[String(variantId)] : null;
    var url = v && v.url != null ? String(v.url).trim() : '';
    if (url) return url;
  }
  var link = productCard.querySelector(CARD_LINK);
  return link ? link.getAttribute('href') || '' : '';
}
function onSwatchInteraction(e) {
  if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
  if (!(e.target instanceof Element)) return;
  var swatchOption = e.target.closest(CARD_COLOR_OPTION);
  if (!swatchOption) return;
  e.preventDefault();
  e.stopPropagation();

  // Always sync the card to the chosen colour first (preview + re-point links).
  changeSwatch(swatchOption);

  // Desktop (hover-capable) click and keyboard activation go straight to the
  // variant PDP. Mobile taps only preview the colour on the card — the shopper
  // navigates by tapping the card image or title instead.
  var navigate = e.type === 'keydown' || isHoverDevice();
  if (!navigate) return;
  var productCard = swatchOption.closest(CARD_PRODUCT);
  if (!productCard) return;
  var url = swatchVariantUrl(swatchOption, productCard);
  if (url) window.location.href = url;
}
function onSwatchHover(e) {
  if (!(e.target instanceof Element)) return;
  var swatchOption = e.target.closest(CARD_COLOR_OPTION);
  if (!swatchOption) return;
  changeSwatch(swatchOption);
}
var preloadedCards = new WeakSet();
function preloadCardVariantImages(card) {
  if (preloadedCards.has(card)) return;
  preloadedCards.add(card);
  var data = parseCardVariants(card);
  if (!(data !== null && data !== void 0 && data.variants)) return;
  // Only preload images for the visible swatch options, not every variant in the payload.
  var visibleSwatchIds = new Set([...card.querySelectorAll("".concat(CARD_COLOR_OPTION, ":not([hidden])"))].map(el => el.dataset.variantId).filter(Boolean));
  for (var _ref3 of Object.entries(data.variants)) {
    var _ref2 = _slicedToArray(_ref3, 2);
    var id = _ref2[0];
    var v = _ref2[1];
    if (!visibleSwatchIds.size || visibleSwatchIds.has(id)) {
      var _v$primary;
      var src = v === null || v === void 0 || (_v$primary = v.primary) === null || _v$primary === void 0 ? void 0 : _v$primary.src;
      if (src) new Image().src = src;
    }
  }
}
function onCardEnter(e) {
  if (!(e.target instanceof Element)) return;
  var card = e.target.closest(CARD_PRODUCT);
  if (card) preloadCardVariantImages(card);
}
document.addEventListener('click', onSwatchInteraction, true);
document.addEventListener('keydown', onSwatchInteraction);
document.addEventListener('mouseenter', onSwatchHover, true);
document.addEventListener('mouseenter', onCardEnter, true);